import Vue from 'vue'

const selectNodeContents = (el: Element, start: number, end: number): void => {
  const textNode: ChildNode = el.childNodes[0]

  const r = document.createRange()
  r.setStart(textNode, start)

  end = end < 0 ? textNode?.textContent?.length || 0 : end
  r.setEnd(textNode, end)

  const s = window.getSelection()
  if (s) {
    s.removeAllRanges()
    s.addRange(r)
  }
}

Vue.directive('select-on-focus', (el, binding) => {
  const defaultRange = {
    start: 0,
    end: -1,
    ...binding.value
  }

  // We bind to the 'focus' event
  el.addEventListener('focus', (ev: FocusEvent) => {
    if (ev.currentTarget === null) {
      return
    }

    const start = parseInt(defaultRange.start, 10)
    const end = parseInt(defaultRange.end, 10)

    if (el.hasAttribute('contenteditable')) {
      selectNodeContents(<Element>ev.currentTarget, start, end)
    } else {
      const input = ev.currentTarget as HTMLInputElement
      input.setSelectionRange(start, end)
    }
  })
})
